import Vue from 'vue'
import App from './App.vue'
import Spinner from './views/Spinner.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import GAuth from 'vue-google-oauth2'
import axios from 'axios'
import mixin from '@/mixin/mixin.js'
import proxy from './proxy/proxy'
import PortalVue from 'portal-vue'
import BaseDialog from './components/UIElements/BaseDialog.vue'
import BaseTextInfo from './components/UIElements/BaseTextInfo.vue'
import BaseDraggableCard from './components/UIElements/BaseDraggableCard.vue'
import BaseWidgetHeader from './components/UIElements/BaseWidgetHeader.vue'
import BasePrimaryBtn from './components/UIElements/BasePrimaryBtn.vue'
import BaseSecondaryBtn from './components/UIElements/BaseSecondaryBtn.vue'
import BaseAutocomplete from './components/UIElements/BaseAutocomplete.vue'
import BaseTextField from './components/UIElements/BaseTextField.vue'
import BaseColorPicker from './components/UIElements/BaseColorPicker.vue'
import BaseDrawToolPicker from './components/UIElements/BaseDrawToolPicker.vue'
import BaseDatePicker from './components/UIElements/BaseDatePicker.vue'
import BaseDisplayField from './components/UIElements/BaseDisplayField.vue'

import { VTooltip } from 'vuetify/lib'
import intercept from '../src/intercept/intercept'
import * as intl from '@arcgis/core/intl'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import '@mdi/font/css/materialdesignicons.css'
import { Buffer } from 'buffer'

Vue.config.productionTip = true
Vue.use(PortalVue)
const production = parseInt(process.env.VUE_APP_PRODUCTION)
export const eventBus = new Vue()
axios.defaults.baseURL = process.env.VUE_APP_REST_URL
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const vm = {
  router: router,
  store: store,
}
let viewerName = null
let type = null

intercept(axios, vm)
new Vue({
  name: 'SmartViewerSpinner',
  store,
  render: h => h(Spinner),
}).$mount('#spinner')
authKey()
window.Buffer = Buffer
window.global = globalThis
async function authKey () {
  const hash = window.location.hash
  const routePath = hash.replace('#/', '')
  try {
    const response = await axios.get('/authInfo/smartPortal')

    const gauthOption = {
      clientId: response.data.google_id,
      scope: 'profile email',
      prompt: 'select_account',
    }
    Vue.use(GAuth, gauthOption)
    Vue.mixin(mixin)

    if (routePath === 'error') {
      initVue()
      return
    }
    if (routePath.includes('/home')) {
      type = 'home'
      viewerName = routePath.replace('/home', '')
    } else if (routePath.includes('/login')) {
      type = 'login'
      viewerName = routePath.replace('/login', '')
    } else {
      type = 'home'
      viewerName = routePath
      window.location = window.location.origin + (production ? '/smartViewer/#/' : '/#') + viewerName + '/home'
    }
    const body = {
      name: viewerName,
    }
    getBasicInfo(body)
  } catch (error) {
    initVue()
    router.push('/error')
    console.error(error)
  }
}
async function getBasicInfo (body) {
  try {
    await validateLicense()
    let response = await axios.post('/basicInfo', body)
    if (response.data.success === false) {
      initVue()
      store.dispatch('setErrorMessage', '404 - Viewer does not exist.')
      router.push('/error')
      return
    }
    if (response.data.active === false) {
      initVue()
      store.dispatch('setErrorMessage', '404 - Viewer is not active.')
      router.push('/error')
      return
    }
    const basicInfo = {
      viewerId: response.data.id,
      viewerName: response.data.name,
      organisationId: response.data.organisationfk,
      organisationName: response.data.organisationName ? response.data.organisationName : '',
      hasLogin: response.data.haslogin,
      ...(response.data.portalUrl && { organisationPortalUrl: response.data.portalUrl }),
      loginMethods: response.data.loginmethods,
      loginPermission: response.data.loginpermissionfk,
      license: response.data.license,
    }
    store.dispatch('setGeneralInfo', basicInfo)
    // get appId for arcGISPortal
    const organisationName = response.data.organisationName
    response = await axios.get('/authInfo/' + organisationName)
    const appId = response.data[organisationName]
    store.dispatch('setPortalAppId', appId)
    initStore(basicInfo.viewerName)
  } catch (error) {
    initVue()
    router.push('/error')
    console.error(error)
  }
}

async function validateLicense () {
  try {
    const response = await axios.get('validateLicense')
    if (response.data.success) {
      store.dispatch('setValidLicense', true)
    } else {
      initVue()
      store.dispatch('setValidLicense', false)
      router.push('/licenseError')
    }
  } catch (error) {
    initVue()
    store.dispatch('setValidLicense', false)
    router.push('/licenseError')
    console.error(error)
  }
}

async function initStore (viewerNameParam) {
  loadLoggedInUserFromLocalStorage(viewerNameParam)
  loadLanguageFromLocalStorage(viewerNameParam)
  loadFilterDataFromLocalStorage(viewerNameParam)
  loadLabelingDataFromLocalStorage(viewerNameParam)
  loadSymbologyDataFromLocalStorage(viewerNameParam)
  loadHighlightColorsDataFromLocalStorage(viewerNameParam)
}
async function loadLoggedInUserFromLocalStorage (viewerNameParam) {
  // ili ako ima access token
  let multiParametars = false
  if (window.location.search.includes('queryConfig=') || window.location.search.includes('extent=') || window.location.search.includes('startupView=')) {
    multiParametars = true
  }
  let accessToken = ''
  if (window.location.search?.split('?access_token=')[1]) {
    accessToken = window.location.search?.split('?access_token=')[1].split('&')[0]
  }
  let localStorageViewerData = {}
  let acceptedTerms = false
  if ((store.getters.getHasLogin !== 0 && localStorage.getItem(window.location.host + '-' + viewerNameParam + '-loggedInUser')) || accessToken) {
    if (!localStorage.getItem(window.location.host + '-' + viewerNameParam + '-loggedInUser')) {
      const token = decodeURI(accessToken).replaceAll('+', ' ')
      const response = await axios.post('/getUserFromToken', { access_token: token, viewer: store.getters.getViewerId.toString() })
      if (response.data.token) {
        store.dispatch('setLoggedInUser', response.data.loggedInUser)
        store.dispatch('setAccessToken', response.data.token)
        store.dispatch('setRefreshToken', response.data.refresh_token)
      }
      localStorageViewerData.token = response.data.token
      const user = {
        loggedInUser: response.data.loggedInUser,
        token: response.data.token,
        refreshToken: response.data.refresh_token,
      }
      const viewerName = store.getters.getViewerName
      localStorage.setItem(window.location.host + '-' + viewerName + '-loggedInUser', JSON.stringify(user))
      if (localStorage.getItem(window.location.host + '-' + viewerNameParam + '-acceptedTerms')) {
        acceptedTerms = localStorage.getItem(window.location.host + '-' + viewerNameParam + '-acceptedTerms')
        store.dispatch('setAcceptedTerms', acceptedTerms)
      } else {
        localStorage.setItem(window.location.host + '-' + viewerName + '-acceptedTerms', false)
        store.dispatch('setAcceptedTerms', false)
      }
      if (!multiParametars) {
        window.history.replaceState(null, null, window.location.pathname + window.location.hash)
      }
    } else {
      localStorageViewerData = JSON.parse(localStorage.getItem(window.location.host + '-' + viewerNameParam + '-loggedInUser'))
      if (localStorage.getItem(window.location.host + '-' + viewerNameParam + '-acceptedTerms')) {
        acceptedTerms = localStorage.getItem(window.location.host + '-' + viewerNameParam + '-acceptedTerms')
      } else {
        acceptedTerms = false
      }
      store.dispatch('setLoggedInUser', localStorageViewerData.loggedInUser)
      store.dispatch('setAccessToken', localStorageViewerData.token)
      store.dispatch('setRefreshToken', localStorageViewerData.refreshToken)
      store.dispatch('setAcceptedTerms', acceptedTerms)
    }
    const response = await axios.get('userDetails', {
      headers: {
        Authorization: 'Bearer ' + localStorageViewerData.token,
      },
    })
    const userObject = {
      loggedInUser: store.getters.getLoggedInUser,
      token: store.getters.getAccessToken,
      refreshToken: store.getters.getRefreshToken,
      roles: response.data.roles,
      attachmentPrivileges: response.data.attachmentPrivileges,
      queryDefs: response.data.queryDefs,
      forbiddenWidgets: response.data.forbiddenWidgets,
      extents: response.data.extents,
    }
    store.dispatch('doLogin', userObject)
    const body = {
      viewer: viewerNameParam,
      type: 'get',
    }
    getConfigJson(body)
  } else {
    const body = {
      viewer: viewerNameParam,
      type: 'get',
    }
    getConfigJson(body)
  }
}
function loadLanguageFromLocalStorage (viewerNameParam) {
  if (localStorage.getItem(window.location.host + '-' + viewerNameParam + '-language')) {
    const localStorageViewerData = JSON.parse(localStorage.getItem(window.location.host + '-' + viewerNameParam + '-language'))
    if (['sr', 'cir', 'ba'].includes(localStorageViewerData.language)) {
      intl.setLocale('sr')
    } else {
      intl.setLocale('en-US')
    }
    const data = {
      language: localStorageViewerData.language,
      viewer: viewerNameParam,
      host: window.location.host,
    }
    store.dispatch('setLanguage', data)
  }
}

function loadHighlightColorsDataFromLocalStorage (viewerNameParam) {
  let savedHighlightColors = null

  if (localStorage.getItem(window.location.host + '-' + viewerNameParam + '-highlightColors')) {
    savedHighlightColors = localStorage.getItem(window.location.host + '-' + viewerNameParam + '-highlightColors')
  }
  if (savedHighlightColors) {
    store.dispatch('setHighlightColorsFromLocalStorage', savedHighlightColors)
  }
}

export function loadSymbologyDataFromLocalStorage (viewerNameParam) {
  let savedSymbology = null

  if (localStorage.getItem(`symbology-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))) {
    savedSymbology = localStorage.getItem(`symbology-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))
  }
  if (savedSymbology) {
    store.dispatch('loadSymbologyFromLocalStorage', savedSymbology)
  }
}

export function loadFilterDataFromLocalStorage (viewerNameParam) {
  let savedFilters = null

  if (localStorage.getItem(`filters-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))) {
    savedFilters = localStorage.getItem(`filters-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))
  }

  if (savedFilters) {
    store.dispatch('loadFiltersFromLocalStorage', savedFilters)
  }
}

export function loadLabelingDataFromLocalStorage (viewerNameParam) {
  let savedLabeling = null

  if (localStorage.getItem(`labeling-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))) {
    savedLabeling = localStorage.getItem(`labeling-${viewerNameParam}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : ''))
  }
  if (savedLabeling) {
    store.dispatch('loadLabelingFromLocalStorage', savedLabeling)
  }
}

async function getConfigJson (body) {
  try {
    const response = await axios.post('configPortal', body)
    if (response.data.success === true) {
      const configJson = response.data.configJson
      store.dispatch('setConfigJson', configJson)
      if (store.getters.getLanguage === null || store.getters.getLanguage === '') {
        const language = configJson.appConfig.localization ? configJson.appConfig.localization[0].id : 'en'

        if (['sr', 'cir', 'ba'].includes(language)) {
          intl.setLocale('sr')
        } else {
          intl.setLocale('en-US')
        }
        const data = {
          language: language,
          viewer: store.getters.getViewerName,
          host: window.location.host,
        }
        store.dispatch('setLanguage', data)
      }
      if (configJson.appConfig.localization ? !!configJson.appConfig.localization[0].disclaimer : false) {
        store.dispatch('setHasDisclaimer', true)
      } else {
        store.dispatch('setHasDisclaimer', false)
      }
      if (configJson.appConfig?.tablogo) {
        const favicon = document.getElementById('favicon')
        favicon.href = configJson.appConfig.tablogo
      } else if (configJson.appConfig?.logo) {
        const favicon = document.getElementById('favicon')
        favicon.href = configJson.appConfig.logo
      }
      if (configJson.appConfig?.queryDistance) {
        store.dispatch('setQueryDistance', configJson.appConfig.queryDistance)
      }
      if (configJson.appConfig?.defaultHighlightColor) {
        store.dispatch('setDefaultHighlightColor', configJson.appConfig.defaultHighlightColor)
      }
      if (configJson.appConfig?.defaultHighlightLineWidth) {
        store.dispatch('setDefaultHighlightLineWidth', configJson.appConfig.defaultHighlightLineWidth)
      }
      if (configJson.appConfig?.defaultHighlightPolygonOutlineWidth) {
        store.dispatch('setDefaultHighlightPolygonOutlineWidth', configJson.appConfig.defaultHighlightPolygonOutlineWidth)
      }
      if (configJson.appConfig?.defaultHighlightPolygonFillStyle) {
        store.dispatch('setDefaultHighlightPolygonFillStyle', configJson.appConfig.defaultHighlightPolygonFillStyle)
      }

      const loggedInUser = store.getters.getLoggedInUser
      if (store.getters.getHasLogin === 0) {
        initPublicMode()
      } else {
        const token = store.getters.getAccessToken
        if (loggedInUser && token) {
          proxy(token, configJson)
        }
        if (loggedInUser == null && store.getters.getHasLogin === 2) {
          initMixedMode()
        } else {
          initVue()
        }
      }
    } else {
      console.error('Wrong config json')
      const basic = {
        viewerId: null,
        viewerName: null,
        clientId: null,
        hasLogin: null,
      }
      store.dispatch('setGeneralInfo', basic)
      if (response.data.message.startsWith('File not found')) {
        store.dispatch('setErrorMessage', 'Not found config.json')
      } else {
        store.dispatch('setErrorMessage', 'Wrong config.json format.')
      }
      initVue()
      router.push('/error')
    }
  } catch (error) {
    initVue()
    router.push('/error')
    console.error(error)
  }
}

async function initMixedMode () {
  const input = {
    viewerfk: store.getters.getViewerId,
    organisationfk: store.getters.getOrganisationId,
  }
  try {
    const response = await axios.post('mixedAuth', input)
    const mixedInfo = response.data
    store.dispatch('doMixedAuth', mixedInfo)
    proxy(store.getters.getAccessToken, store.getters.getConfigJson)
    initVue()
  } catch (error) {
    initVue()
    router.push('/error')
    console.error(error)
  }
}

async function initPublicMode () {
  const input = {
    viewer: store.getters.getViewerName,
  }
  try {
    const response = await axios.post('publicToken', input)
    const info = response.data
    store.dispatch('doMixedAuth', info)
    proxy(store.getters.getAccessToken, store.getters.getConfigJson)
    initVue()
  } catch (error) {
    initVue()
    router.push('/error')
    console.error(error)
  }
}

function initVue () {
  const elementsCss = document.getElementsByClassName('customCss')
  while (elementsCss.length > 0) {
    elementsCss[0].parentNode.removeChild(elementsCss[0])
  }
  const elementsJs = document.getElementsByClassName('customJs')
  while (elementsJs.length > 0) {
    elementsJs[0].parentNode.removeChild(elementsJs[0])
  }
  const config = store.getters.getConfigJson
  if (config.appConfig?.externalCss?.length > 0) {
    const head = document.getElementsByTagName('head')[0]
    for (const address of config.appConfig.externalCss) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.className = 'customCss'
      link.href = address
      link.media = 'all'
      head.appendChild(link)
    }
  }
  if (config.appConfig?.externalJs?.length > 0) {
    const head = document.getElementsByTagName('head')[0]
    for (const address of config.appConfig.externalJs) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.className = 'customJs'
      script.src = address
      head.appendChild(script)
    }
  }
  if (config.appConfig?.startUpFunction) {
    router.push('/startup/' + viewerName + '/' + type)
  }

  let extentParam = window.location.search?.split('?extent=')[1]
  let viewParam = window.location.search?.split('?startupView=')[1]
  let queryConfigParam = window.location.search?.split('queryConfig=')[1]
  console.log('done')
  if (extentParam) {
    if (extentParam.includes('&')) {
      extentParam = extentParam.split('&')[0]
    }
    loadInitialExtentFromUrl(extentParam)
  }
  if (viewParam) {
    if (viewParam.includes('&')) {
      viewParam = viewParam.split('&')[0]
    }
    loadInitialViewFromUrl(viewParam)
  }
  if (queryConfigParam) {
    if (queryConfigParam.includes('&')) {
      queryConfigParam = queryConfigParam.split('&')[0]
    }
    loadInitialQueryConfigFromUrl(queryConfigParam)
  }
  window.history.replaceState(null, null, window.location.pathname + window.location.hash)
  // load client actions
  const widgets = config.widgets
  if (widgets) {
    const clientActionWidget = widgets.find(element => element.id === 'clientAction')
    if (clientActionWidget?.configured) {
      const script = document.createElement('script')
      const clientActionWidgetConfiguration = store.getters.getConfigJson.widgetConfig.clientAction
      if (clientActionWidgetConfiguration?.filePath) {
        const clientActionUrl = clientActionWidgetConfiguration.filePath
        script.setAttribute('src', clientActionUrl)
        script.type = 'text/javascript'
        document.head.appendChild(script)
      }
    }
  }
  registerGlobalVueUIComponents()
  registerCustomTools()
  new Vue({
    name: 'SmartViewer',
    vuetify,
    store,
    router,
    created () {
      document.title = store.getters.getConfigJson.appConfig?.tabTitle ? store.getters.getConfigJson.appConfig.tabTitle : (store.getters.getViewerName ? store.getters.getViewerName : 'Smart Viewer')
    },
    render: h => h(App),
  }).$mount('#app')
}

function loadInitialExtentFromUrl (extent) {
  const coordinates = extent.split(',')
  const bookmark = {}
  for (const coordinate of coordinates) {
    if (coordinate.startsWith('xmin')) {
      bookmark.xmin = coordinate.split('xmin=')[1]
    } else if (coordinate.startsWith('xmax')) {
      bookmark.xmax = coordinate.split('xmax=')[1]
    } else if (coordinate.startsWith('ymin')) {
      bookmark.ymin = coordinate.split('ymin=')[1]
    } else if (coordinate.startsWith('ymax')) {
      bookmark.ymax = coordinate.split('ymax=')[1]
    }
  }
  store.dispatch('setBookmark', bookmark)
}
function loadInitialViewFromUrl (view) {
  const config = store.getters.getConfigJson
  const views = config.widgetConfig.views.views
  view = decodeURI(view).replaceAll('+', ' ')
  const selectedView = views.find(e => e.name === view)
  if (selectedView) {
    store.dispatch('setViewObject', selectedView)
  }
}
function loadInitialQueryConfigFromUrl (queryConfig) {
  const params = decodeURI(queryConfig).split(';')
  const initialQueryConfig = {}
  for (const param of params) {
    if (param.startsWith('serviceKey')) {
      initialQueryConfig.serviceKey = param.split('serviceKey=')[1]
    } else if (param.startsWith('layerId')) {
      initialQueryConfig.layerId = param.split('layerId=')[1]
    } else if (param.startsWith('where')) {
      initialQueryConfig.where = param.split('where=')[1]
    }
  }
  if (initialQueryConfig.serviceKey && initialQueryConfig.layerId && initialQueryConfig.where) {
    store.dispatch('setQuery', initialQueryConfig)
  }
}

function registerGlobalVueUIComponents () {
  Vue.component('BaseDialog', BaseDialog)
  Vue.component('BaseDraggableCard', BaseDraggableCard)
  Vue.component('BaseTextInfo', BaseTextInfo)
  Vue.component('BaseWidgetHeader', BaseWidgetHeader)
  Vue.component('BasePrimaryBtn', BasePrimaryBtn)
  Vue.component('BaseSecondaryBtn', BaseSecondaryBtn)
  Vue.component('BaseAutocomplete', BaseAutocomplete)
  Vue.component('BaseTextField', BaseTextField)
  Vue.component('BaseColorPicker', BaseColorPicker)
  Vue.component('BaseDrawToolPicker', BaseDrawToolPicker)
  Vue.component('BaseDatePicker', BaseDatePicker)
  Vue.component('BaseDisplayField', BaseDisplayField)
  Vue.component('BaseTooltip', {
    name: 'BaseTooltip',
    extends: VTooltip,
    props: { openDelay: { type: Number, default () { return 500 } } },
  })
}
// register custom tools
function registerCustomTools () {
  if (!(store.getters.getConfigJson?.customTools)) {
    return
  }

  const requireComponent = require.context(
    // The relative path of the custom tools folder
    './customTools',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match custom tool filenames
    /[A-Z]\w+\.(vue)$/
  )
  requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)
    // Get PascalCase name of component
    const componentName = upperFirst(
      camelCase(
        // Gets the file name regardless of folder depth
        fileName
          .split('/')
          .pop()
          .replace(/\.\w+$/, '')
      )
    )
    // Register component globally
    Vue.component(
      componentName,
      // Look for the component options on `.default`, which will
      // exist if the component was exported with `export default`,
      // otherwise fall back to module's root.
      componentConfig.default || componentConfig
    )
  })
}
